import React, { Component } from 'react';
import { Table, Space, message, Popconfirm, Form, Row, Col, Button, Input, Select } from 'antd';
import './style.less';
import send from '../../util/request';
import { dateFormat } from '../../util/tool';
import { formItemLayout2 as formItemLayout } from '../../util/formItemLayoutConfig';

const { Option } = Select;
// 0-未提交 1-已提交 2-已锁定 3-已取消
const statusIndexToText = {
  "-1": "全部",
  "0": "未提交",
  "1": "已提交",
  "2": "已锁定",
  "3": "已取消"
};

const predictionData = {
  "sk000382": {
    "pre1": 26900,
    "pre2": 30200,
    "pre3": 26500,
    "pre4": 20200,
    "pre5": 17000,
    "pre6": 15000,
    "pre7": 15100,
    "pre8": 15800,
    "pre9": 15200,
    "pre10": 16700,
    "pre11": 15100,
    "pre12": 16000,
  },
  "sk000390": {
    "pre1": 3340,
    "pre2": 3602,
    "pre3": 6519,
    "pre4": 7561,
    "pre5": 5906,
    "pre6": 5607,
    "pre7": 4692,
    "pre8": 4502,
    "pre9": 4298,
    "pre10": 4422,
    "pre11": 4394,
    "pre12": 4769,
  }
};

const years = [2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];

class annualPlanOrderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true,
      currentPage: 1,
      pageSize: 10,
    };
  }
  columns = [
    {
      title: '年度',
      dataIndex: 'year',
      key: 'year',
      align: 'center',
    },
    {
      title: '供应商',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      align: 'center',
      width: 180
    },
    {
      title: '供应商编码',
      dataIndex: 'supplier_id',
      key: 'supplier_id',
      align: 'center',
      width: 120
    },
    {
      title: '商品名称',
      dataIndex: 'sale_name',
      key: 'sale_name',
      align: 'center',
      width: 180
    },
    {
      title: '商品编码',
      dataIndex: 'sku_no',
      key: 'sku_no',
      align: 'center',
      width: 120
    },
    {
      title: '等级',
      dataIndex: 'sku_level',
      key: 'sku_level',
      align: 'center',
    },
    {
      title: '产地',
      dataIndex: 'sku_place',
      key: 'sku_place',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'sku_unit_desc',
      key: 'sku_unit_desc',
      align: 'center',
      width: 120
    },
    {
      title: '单位',
      dataIndex: 'sku_unit',
      key: 'sku_unit',
      align: 'center',
    },
    {
      title: '1月计划',
      dataIndex: 'month1',
      key: 'month1',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre1'] || 0);
        record.month1 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month1')}></Input>;
      }
    },
    {
      title: '1月预测',
      dataIndex: 'pre1',
      key: 'pre1',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre1'] || 0;
      }
    },
    {
      title: '2月计划',
      dataIndex: 'month2',
      key: 'month2',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre2'] || 0);
        record.month2 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month2')}></Input>;
      }
    },
    {
      title: '2月预测',
      dataIndex: 'pre2',
      key: 'pre1',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre2'] || 0;
      }
    },
    {
      title: '3月计划',
      dataIndex: 'month3',
      key: 'month3',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre3'] || 0);
        record.month3 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month3')}></Input>;
      }
    },
    {
      title: '3月预测',
      dataIndex: 'pre3',
      key: 'pre3',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre3'] || 0;
      }
    },
    {
      title: '4月计划',
      dataIndex: 'month4',
      key: 'month4',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre4'] || 0);
        record.month4 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month4')}></Input>;
      }
    },
    {
      title: '4月预测',
      dataIndex: 'pre4',
      key: 'pre4',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre4'] || 0;
      }
    },
    {
      title: '5月计划',
      dataIndex: 'month5',
      key: 'month5',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre5'] || 0);
        record.month5 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month5')}></Input>;
      }
    },
    {
      title: '5月预测',
      dataIndex: 'pre5',
      key: 'pre5',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre5'] || 0;
      }
    },
    {
      title: '6月计划',
      dataIndex: 'month6',
      key: 'month6',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre6'] || 0);
        record.month6 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month6')}></Input>;
      }
    },
    {
      title: '6月预测',
      dataIndex: 'pre6',
      key: 'pre6',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre6'] || 0;
      }
    },
    {
      title: '7月计划',
      dataIndex: 'month7',
      key: 'month7',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre7'] || 0);
        record.month7 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month7')}></Input>;
      }
    },
    {
      title: '7月预测',
      dataIndex: 'pre7',
      key: 'pre7',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre7'] || 0;
      }
    },
    {
      title: '8月计划',
      dataIndex: 'month8',
      key: 'month8',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre8'] || 0);
        record.month8 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month8')}></Input>;
      }
    },
    {
      title: '8月预测',
      dataIndex: 'pre8',
      key: 'pre8',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre8'] || 0;
      }
    },
    {
      title: '9月计划',
      dataIndex: 'month9',
      key: 'month9',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre9'] || 0);
        record.month9 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month9')}></Input>;
      }
    },
    {
      title: '9月预测',
      dataIndex: 'pre9',
      key: 'pre9',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre9'] || 0;
      }
    },
    {
      title: '10月计划',
      dataIndex: 'month10',
      key: 'month10',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre10'] || 0);
        record.month10 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month10')}></Input>;
      }
    },
    {
      title: '10月预测',
      dataIndex: 'pre10',
      key: 'pre10',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre10'] || 0;
      }
    },
    {
      title: '11月计划',
      dataIndex: 'month11',
      key: 'month11',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre11'] || 0);
        record.month11 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month11')}></Input>;
      }
    },
    {
      title: '11月预测',
      dataIndex: 'pre11',
      key: 'pre11',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre11'] || 0;
      }
    },
    {
      title: '12月计划',
      dataIndex: 'month12',
      key: 'month12',
      align: 'center',
      render: (text, record) => {
        text = Number(text).toFixed(0);
        let values = predictionData[record.sku_no] || {};
        let value = text > 0 ? text : (values['pre12'] || 0);
        record.month12 = value;
        return !record.isEditing ? <span>{value}</span> : <Input value={value} onChange={(event) => this.valueChanged(event, record, 'month12')}></Input>;
      }
    },
    {
      title: '12月预测',
      dataIndex: 'pre12',
      key: 'pre12',
      align: 'center',
      render: (text, record) => {
        let values = predictionData[record.sku_no] || {};
        return values['pre12'] || 0;
      }
    },
    {
      title: '合计',
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      render: (text, record) => {
        const { month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12 } = record;
        let total = +(month1) + +(month2) + +(month3) + +(month4) + +(month5) + +(month6) + +(month7) + +(month8) + +(month9) + +(month10) + +(month11) + +(month12);
        return total;
      }
    },
    {
      title: '创建者',
      dataIndex: 'op_account',
      key: 'op_account',
      align: 'center',
      width: 160
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (text, record) => (
        <span>{statusIndexToText[record.status]}</span>
      )
    },
    {
      title: '提交时间',
      dataIndex: 'commit_time',
      key: 'commit_time',
      align: 'center',
      width: 120,
      render: (text, record) => {
        return record.commit_time <= 0 ? '-' : dateFormat(new Date(record.commit_time * 1000), 'yyyy-MM-dd hh:mm:ss');
      }
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 150,
      render: (text, record) => (
        <Space size="middle">
          {+(record.status) === 0 && !record.isEditing && (
            <Popconfirm
              title="是否要提交?"
              onConfirm={() => this.handleSubmit(record, 1)}
              okText="确定"
              cancelText="取消">
              <a>提交</a>
            </Popconfirm>)
          }
          {
            +(record.status) !== 2 && !record.isEditing && (
              <a onClick={() => this.handleEdit(record)}>调整</a>
            )
          }
          {
            +(record.status) === 0 && !record.isEditing && (
              <Popconfirm
                title="是否要删除?"
                onConfirm={() => this.handleDelete(record)}
                okText="确定"
                cancelText="取消">
                <a>删除</a>
              </Popconfirm>
            )
          }
          {
            record.isEditing && (
              <a onClick={() => this.handleSave(record)}>保存</a>
            )
          }
        </Space>
      ),
    },
  ]

  formRef = React.createRef();

  componentDidMount() {
    this.requestDemandPlanList();
    this.setState = () => false;
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  handleQuery = (values) => {
    const { year = '', productName = '', productCode = '', status = -1 } = values;
    this.setState({
      year,
      productName,
      productCode,
      status,
      currentPage: 1,
    });;
    this.requestDemandPlanList();
  }
  handleReset = () => {
    this.formRef.current.resetFields();
    this.setState({
      currentPage: 1,
      year: '',
      productName: '',
      productCode: '',
      status: -1
    }, () => {
      this.requestDemandPlanList();
    });
  }
  addDemandPlan = () => {
    this.props.history.push('/basic/user/annualPlanOrder/detail');
  }
  requestDemandPlanList() {
    const { year = '', productName = '', productCode = '', status = -1, currentPage, pageSize } = this.state;
    let params = {
      year: year,
      status: status,
      sale_name: productName,
      sku_no: productCode,
      page: currentPage,
      limit: pageSize,
    };;
    if (+(status) === -1) {
      delete params.status;
    }
    send({
      url: '/ipp/order-plan-year/select',
      method: 'GET',
      params,
      options: { loading: true }
    }).then((res) => {
      this.setState({
        loading: false
      });
      if (res.data && res.data.code === 0) {
        let { list = [], total } = res.data.data;
        this.setState({
          list,
          total
        });
      }
    }, () => {
      this.setState({ loading: false });
    });
  }
  handleSubmit = (record, type) => {
    let array = [];
    let count = 0; // 未填写计划的订单数量
    if (type === 1) {
      const { month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12 } = record;
      let total = +(month1) + +(month2) + +(month3) + +(month4) + +(month5) + +(month6) + +(month7) + +(month8) + +(month9) + +(month10) + +(month11) + +(month12);
      count = !total ? 1 : 0;
      array = [record.id];
    } else {
      array = this.state.addList.map(obj => {
        const { month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12 } = obj;
        let total = +(month1) + +(month2) + +(month3) + +(month4) + +(month5) + +(month6) + +(month7) + +(month8) + +(month9) + +(month10) + +(month11) + +(month12);
        if (!total) { count++; }
        return obj.id;
      });
    }

    if (count) {
      message.info('请补充计划数量');
      return;
    }

    let data = {
      plan_order_year_ids: array.join(','),
      status: 1  //0-未提交 1-已提交 2-已锁定 3-已取消
    };
    send({
      url: '/ipp/order-plan-year/modify',
      method: 'POST',
      data
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success('提交成功');
        this.setState({
          isBatchAdd: false,
          addList: [],
          selectedRowKeys: [],
        });
        this.requestDemandPlanList();
      }
    });
  }
  handleEdit = (record) => {
    let { list } = this.state;
    let currentIndex = list.findIndex(obj => String(obj.id) === String(record.id));
    if (currentIndex !== -1) {
      list = list.map((item, index) => index === currentIndex ? { ...item, isEditing: true } : item);
      this.setState({ list });
    }
  }
  valueChanged = (event, record, key) => {
    let value = event.target.value;
    value = Number(value.replace(/\D/g, ''));
    let { list } = this.state;
    let currentIndex = list.findIndex(obj => String(obj.id) === String(record.id));
    if (currentIndex !== -1) {
      list = list.map((item, index) => index === currentIndex ? { ...item, [key]: value } : item);
      this.setState({ list });
    }
  }
  handleSave = (record) => {
    let { list } = this.state;
    let currentIndex = list.findIndex(obj => String(obj.id) === String(record.id));
    if (currentIndex !== -1) {
      list = list.map((item, index) => index === currentIndex ? { ...item, isEditing: false } : item);
      this.setState({ list });
    }

    // 更新数量
    const { id, month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12 } = record;
    let data = { plan_order_year_id: id, month1, month2, month3, month4, month5, month6, month7, month8, month9, month10, month11, month12, };
    send({
      url: '/ipp/order-plan-year/set-year-num',
      method: 'POST',
      data
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success('数量更新成功');
        this.requestDemandPlanList();
      }
    });

  }
  handleDelete = (record) => {
    if (!record) { return; }

    let data = {
      plan_order_year_id: record.id,
    };
    send({
      url: '/ipp/order-plan-year/del',
      method: 'POST',
      data
    }).then(res => {
      if (res.data && res.data.code === 0) {
        message.success('删除成功');
        this.requestDemandPlanList();
      }
    });
  }
  render() {
    const { list, loading, selectedRowKeys, isBatchAdd, currentPage, pageSize, total } = this.state;

    const chooseCheck = {
      selectedRowKeys,
      getCheckboxProps: (record) => ({
        disabled: record.status !== 0,  // 只有未提交的才可以勾选
      }),
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          isBatchAdd: selectedRowKeys.length > 0 ? true : false,
          addList: selectedRows,
          selectedRowKeys,
        });
      },
    };

    return (
      <div className="annual-plan-order-list">
        <div className="title">年度计划管理</div>
        <div style={{ marginTop: '20px' }}>
          <Form
            ref={this.formRef}
            {...formItemLayout}
            onFinish={this.handleQuery}>
            <Row>
              <Col span={8}>
                <Form.Item label='计划年份' name="year">
                  <Select placeholder='请选择年份'>
                    {
                      years.sort().map(obj => <Option key={obj} value={obj}>{obj}年</Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品名称' name="productName">
                  <Input maxLength={100} placeholder='请输入商品名称' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='商品编码' name="productCode">
                  <Input maxLength={100} placeholder='请输入商品中心编码' />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label='状态' name="status">
                  <Select placeholder='请选择状态'>
                    {
                      Object.keys(statusIndexToText).sort().map(obj => <Option key={obj} value={obj}>{statusIndexToText[obj]}</Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                <Button type='primary' htmlType='submit'>查询</Button>
                <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>重置</Button>
              </Col>
            </Row>
          </Form>
        </div>
        <div style={{ margin: '20px 20px' }}>
          <Button type='primary' onClick={this.addDemandPlan}>新建年度计划</Button>
          <Button disabled={!isBatchAdd} style={{ marginLeft: '20px' }} type='primary' onClick={this.handleSubmit}>批量提交</Button>
        </div>
        <div>
          <Table
            rowKey={record => record.id}
            columns={this.columns}
            dataSource={list}
            loading={loading}
            scroll={{ x: 5500 }}
            rowSelection={chooseCheck}
            pagination={{
              pageSize: pageSize,
              total: total,
              current: currentPage,
              onChange: (currentPage, pageSize) => {
                this.setState(
                  {
                    currentPage,
                    pageSize,
                  },
                  () => {
                    this.requestDemandPlanList();
                  }
                );
              },
            }}
          />
        </div>
      </div>
    );
  }
}
export default annualPlanOrderList;